import React from 'react';
import { Terminal } from 'xterm';
import './xterm.css';
import Paho from 'paho-mqtt';
import Button from '../button/Button';
import ClientTable from '../reacttable/ClientSideTable'

var terminal;


class XTerminal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: "",
            data: [],
            deviceAttributes: {},
            statusTerminal: "",
            setButtons: false,
        }
        this.handleMenu = this.handleMenu.bind(this);
        this.handleRun = this.handleRun.bind(this);
        this.extractValues = this.extractValues.bind(this);
        this.startTerminal = this.startTerminal.bind(this);

        this.columns = [
                    
            {
                Header: "0%",
                accessor: "0",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
            {
                Header: "100%",
                accessor: "100",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
            {
                Header: "ALRM%",
                accessor: "ALRM",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
            {
                Header: "WARN%",
                accessor: "WARN",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
            {
                Header: "LEVEL1",
                accessor: "LEVEL1",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
            {
                Header: "LEVEL2",
                accessor: "LEVEL2",
                className: "text-center",
                headerClassName: "react-table-header-class"
            },
        ]


    }
    

    componentDidMount() {
        const data = this._reactInternalFiber._debugOwner.stateNode.props.location.state.data
        this.setState({deviceAttributes : data}, () => {
            console.log(this.state.deviceAttributes, 'data');
          })
        console.log(this.state.deviceAttributes)
        //console.log(this._reactInternalFiber._debugOwner.stateNode.props.location.state.data.publishName)
    }

    startTerminal() {

        if(this.state.statusTerminal === "") {
            terminal = new Terminal({cursorBlink: true});
            terminal.open(this.refs.terminal);
            this.setState({ statusTerminal: "open" });

            const client = new Paho.Client("37.148.211.63", Number(9001), "localhost");//String.raw`${this.state.data.identity}`);

            // set callback handlers
            client.onConnectionLost = (responseObject) => {
                if (responseObject.errorCode !== 0) {
                    console.log("onConnectionLost:"+responseObject.errorMessage);
                }
            }
            client.onMessageArrived = (message) => {
                let _msg = JSON.parse(message.payloadString)
                //console.log(_msg)
                if (_msg.code === 1){
                    let msg = String.raw`${_msg.data}`
                    //let msg = String.raw`${message.payloadString}`
    
                    let y = msg.split(String.raw`\x1B`).join('\x1B')
                    terminal.write(y)
                    this.extractValues(msg)
                }
                else if(_msg.code === 6){
                    alert("Cihaz Sample almaktadır. Bekleme Süresi: En fazla 45 saniye.")
                }


            };
            
            // connect the client
            client.connect({onSuccess:() => {

                this.setState({client})
                this.setState({ setButtons : true })
                client.subscribe(this.state.deviceAttributes.publishName);

                const data = JSON.stringify({"LiveConnect": "True", "command" : "Run"})
                const run = new Paho.Message(data);
                run.destinationName = this.state.deviceAttributes.subscribeName;
                this.state.client.send(run);
                
            }});
        } else {
            this.setState({ statusTerminal: "" });
            //client.disconnet()
            
        }

    }

    terminalButtons() {

    }

    handleMenu() {
        const data = JSON.stringify({"LiveConnect": "True", "command" : "Menu"})
        const menu = new Paho.Message(data);
        menu.destinationName = this.state.deviceAttributes.subscribeName;
        this.state.client.send(menu);
    }

    handleRun() {
        const data = JSON.stringify({"LiveConnect": "True", "command" : "Run"})
        const run = new Paho.Message(data);
        run.destinationName = this.state.deviceAttributes.subscribeName;
        this.state.client.send(run);
    }

    extractValues(msg) {
        msg.split(String.raw`\x1B`).forEach((array) => {
            if (array.search(String.raw`7;17H`) !== -1){
                let _array = array.substring(6).split('  ').join(' ').split(' ')
                this.setState(prevState => ({
                    data: [...prevState.data, {
                        0: _array[0],
                        100: _array[1],
                        ALRM: _array[2],
                        WARN: _array[3],
                        LEVEL1: _array[4],
                        LEVEL2: _array[5]
                    }]
                }))
                
            }
        })
    }


    



    render() {
        return(
            <div>
                <div ref="terminal"></div>

                    {
                        this.state.setButtons ? (
                            <div>
                                <Button
                                className='c-btn c-success c-btn-round ma-5'
                                    onClick={this.handleMenu}
                                >
                                    Menu
                                </Button>

                                <Button
                                    className='c-btn c-danger c-btn-round ma-5'
                                    onClick={this.handleRun}
                                >
                                    Run
                                </Button>
                            </div>
                        ) : (
                            <div>
                                <Button
                                    className='c-btn c-success c-btn-round ma-5'
                                    onClick={this.startTerminal}
                                >
                                    Terminali Başlat
                                </Button> 
                            </div>                     
                        )
                    }
                    <ClientTable 
                        data={this.state.data}
                        columns={this.columns}
                    />
            </div>

        )
    }
}

export default XTerminal;